import { cn } from "@/lib/utils";

/**
 * The context a task carries besides its title — the bounced address and Postmark's own reason, the
 * document a jurist has to chase. `createTaskForAssignedAdmin` callers have been writing it all
 * along; until now nothing rendered it, so it only ever existed in the database.
 *
 * Writers compose it as one fact per line, so the paragraph keeps the newlines.
 */
export function TaskText({
  text,
  clamped = false,
  className,
}: {
  text?: string | null;
  clamped?: boolean;
  className?: string;
}) {
  if (!text?.trim()) {
    return null;
  }

  return (
    <p
      className={cn(
        "mt-0.5 whitespace-pre-line text-xs leading-relaxed text-gray-500",
        clamped && "line-clamp-2",
        className,
      )}
    >
      {text}
    </p>
  );
}
